import React, { Component } from 'react';
import request from 'utils/request_ajax';
import { routes as ROUTES } from 'constants/config';
import { Icon } from 'ui';
import ListItem from '../ContentTagging/Tag';
import CollapsibleList from './CollapsibleList';
import GroupedItems from './GroupedItems';
import RemoteAutoComplete from '../RemoteAutoComplete';

const proxyOnClickOption = options => arg =>
  options.map(option => ({
    ...option,
    onClick: e => option.onClick.call(e, arg),
  }));

const filterSuggestions = (ownerships, getOwner) => suggestions => {
  const selectedIds = ownerships.map(ownership => getOwner(ownership).id);
  return suggestions.filter(({ id }) => !selectedIds.includes(id));
};

class ContentOwnership extends Component {
  constructor() {
    super();
    this.state = {
      admins: null,
      adminsExpanded: false,
      adminsLoading: false,
    };
    this.handleAdminsClick = this.handleAdminsClick.bind(this);
    this.renderOwnership = this.renderOwnership.bind(this);
  }

  static defaultProps = {
    automaticOwnersRoute:
      ROUTES.OWNERSHIPS_PEOPLE + '?ownership_type=automatic_ownership',
    sharedOwnersRoute:
      ROUTES.OWNERSHIPS_PEOPLE + '?ownership_type=shared_ownership&limit=10',
    filterSuggestions,
    getOwner: ownership => ownership.owner,
    getAdminName: admin => admin.name,
    mapResponseToAdmins: response => response.owners,
    mapResponseToSuggestions: response => response.owners,
  };

  getAdmins() {
    return new Promise(resolve => {
      if (this.state.admins) {
        resolve(this.state.admins);
      } else {
        this.setState({ adminsLoading: true });
        request.get(this.props.automaticOwnersRoute).then(response => {
          this.setState({ adminsLoading: false });
          resolve(this.props.mapResponseToAdmins(response));
        });
      }
    });
  }

  handleAdminsClick() {
    this.getAdmins().then(admins => {
      this.setState(state => ({
        admins,
        adminsExpanded: !state.adminsExpanded,
      }));
    });
  }

  renderOwnership(ownership) {
    const { editing, getOwnershipOptions, getOwner } = this.props;
    const owner = getOwner(ownership);
    const options = getOwnershipOptions(ownership);
    const $options = proxyOnClickOption(options)(ownership);
    return (
      <ListItem key={ownership.id} options={$options} editing={editing}>
        <span>
          {owner.name}
          {ownership.permission === 'edit_and_view_activity' && (
            <Icon
              name="activity"
              className="ml-4 c-brand-gray-light h-c-gray-darker"
              data-toggle="tooltip"
              data-original-title="This person can view everyone's activity on this Path and all its Lessons."
            />
          )}
        </span>
      </ListItem>
    );
  }

  render() {
    const { props } = this;
    return (
      <div className="mb-0-lc">
        {props.editing && (
          <RemoteAutoComplete
            onSuggestionSelected={props.onCreateOwnership}
            placeholder="Add a Person by Name"
            className="NewInput NewInput--light NewInput--fw mb-16"
            url={props.sharedOwnersRoute}
            filterSuggestions={props.filterSuggestions(
              props.ownerships,
              props.getOwner,
            )}
            mapResponseToSuggestions={props.mapResponseToSuggestions}
          />
        )}
        <GroupedItems
          label={t('ownership.heading.automatic_owners')}
          onClick={this.handleAdminsClick}
          items={this.state.admins}
          loading={this.state.adminsLoading}
          expanded={this.state.adminsExpanded}
          renderItem={admin => (
            <ListItem key={admin.id} name={props.getAdminName(admin)} />
          )}
        />
        <CollapsibleList collapsible={!props.editing}>
          {props.ownerships.map(this.renderOwnership)}
        </CollapsibleList>
        {props.editing && (
          <div className="d-f jc-e ai-c mt-16">
            <button
              type="button"
              className="ml-16 NewButton NewButton--blue NewButton--wide NewButton--center"
              onClick={props.toggleEditing}
              children="Done"
            />
          </div>
        )}
      </div>
    );
  }
}

export default ContentOwnership;
